<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="OT">Contents</p>
<p class="CON1" id="toc2"><a href="#/Oakes_A_Theology_of_Grace6#_idTextAnchor001">Foreword</a></p>
<p class="CON1" id="toc3"><a href="#/Oakes_A_Theology_of_Grace7#_idTextAnchor002">Acknowledgments</a></p>
<p class="CON1" id="toc4"><a href="#/Oakes_A_Theology_of_Grace8#_idTextAnchor003">Introduction</a></p>
<p class="CON1" id="toc5"><a href="#/Oakes_A_Theology_of_Grace9#_idTextAnchor004">1. Nature and Grace</a></p>
<p class="CON1" id="toc6"><span href="#/Oakes_A_Theology_of_Grace10#_idTextAnchor005" title="Link target outside of Sample">2. Sin and Justification</span></p>
<p class="CON1" id="toc7"><span href="#/Oakes_A_Theology_of_Grace11#_idTextAnchor006" title="Link target outside of Sample">3. Evolution and Original Sin</span></p>
<p class="CON1" id="toc8"><span href="#/Oakes_A_Theology_of_Grace12#_idTextAnchor007" title="Link target outside of Sample">4. Free Will and Predestination</span></p>
<p class="CON1" id="toc9"><span href="#/Oakes_A_Theology_of_Grace13#_idTextAnchor008" title="Link target outside of Sample">5. Experience and Divinization</span></p>
<p class="CON1" id="toc10"><span href="#/Oakes_A_Theology_of_Grace14#_idTextAnchor009" title="Link target outside of Sample">6. Mary, Mediatrix of Graces</span></p>
<p class="CON1" id="toc11"><span href="#/Oakes_A_Theology_of_Grace15#_idTextAnchor010" title="Link target outside of Sample">Glossary of Terms</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Oakes_A_Theology_of_Grace5.vue?5097b342